import {
  EditorContent,
  useEditor,
  type Editor as TiptapEditor,
  type JSONContent,
} from '@tiptap/react';
import { useEffect, useMemo } from 'react';
import { getExtensions } from './extensions';
import {
  DefaultBubbleMenu,
  ImageBubbleMenu,
  TableBubbleMenu,
  VideoBubbleMenu,
} from './Menus/BubbleMenu';
import { DefaultFloatingMenu } from './Menus/DefaultFloatingMenu';
import { useEditorStyles } from './useEditorStyles';
import { useTiptapFileSrcResolverFromContext } from './useTiptapFileSrc';

// TODO: temporary style management. This is not a good pattern to repeat,
//       we need to consider using something like emotion to manage these styles

function Editor({
  initialContent,
  onChange,
  readOnly = false,
  onEditorReady,
}: {
  initialContent?: JSONContent;
  onChange: (content: JSONContent) => void;
  readOnly?: boolean;
  onEditorReady?: (editor: TiptapEditor) => void;
}) {
  useEditorStyles();
  const resolveFileSrc = useTiptapFileSrcResolverFromContext();
  const extensions = useMemo(() => getExtensions(resolveFileSrc), [resolveFileSrc]);

  const editor = useEditor({
    extensions,
    content: '',
    onUpdate: ({ editor }) => {
      onChange(editor.getJSON());
    },
    editable: !readOnly,
    editorProps: {
      attributes: {
        class: 'duke-tiptap-editor',
      },
    },
  });

  useEffect(() => {
    if (editor && initialContent) {
      editor.commands.setContent(initialContent);
    }
  }, [editor, initialContent]);

  useEffect(() => {
    if (editor) {
      onEditorReady?.(editor);
    }
  }, [editor, onEditorReady]);

  return (
    <>
      <EditorContent
        editor={editor}
        className={readOnly ? 'duke-tiptap-readonly' : 'duke-tiptap-default'}
      />
      <DefaultBubbleMenu editor={editor} />
      <ImageBubbleMenu editor={editor} />
      <VideoBubbleMenu editor={editor} />
      <TableBubbleMenu editor={editor} />
      <DefaultFloatingMenu editor={editor} />
    </>
  );
}

export default Editor;
